export const diamondShapeImg = {
  RB: '/next-static/images/ui/diamond-search/rb.png',
  PR: '/next-static/images/ui/diamond-search/pr.png',
  SQCUS: '/next-static/images/ui/diamond-search/cus.png',
  CUS: '/next-static/images/ui/diamond-search/cus.png',
  EC: '/next-static/images/ui/diamond-search/ec.png',
  AS: '/next-static/images/ui/diamond-search/as.png',
  SQR: '/next-static/images/ui/diamond-search/sqr.png',
  OV: '/next-static/images/ui/diamond-search/ov.png',
  RAD: '/next-static/images/ui/diamond-search/rad.png',
  MQ: '/next-static/images/ui/diamond-search/mq.png',
  PS: '/next-static/images/ui/diamond-search/ps.png',
  HS: '/next-static/images/ui/diamond-search/hs.png',
}
